import { checkAssignedOrganizations, collectOrgIdsForAnyOrgPermission, requireAnyOrgPermission, requireAnySystemPermission, } from '../../../../../../backend/features/permissions/shared';
import { AuthError } from '@juvare/platform-app/App';
export const onAuthGet = (appState, userState, response) => {
    return authGroupGet(userState, response);
};
export const onAuthList = (appState, userState, response) => {
    const rows = [];
    for (const row of response.rows) {
        rows.push(authGroupList(userState, row));
    }
    response.rows = rows;
    return response;
};
function checkOrganizations(params, organizations) {
    if (params.action === 'create' || params.action === 'update') {
        const organizationIds = Array.isArray(params.data.visibility) ? params.data.visibility : [];
        if (organizationIds.length) {
            checkAssignedOrganizations(organizations, organizationIds);
        }
    }
}
export const onAuthPost = (appState, userState, params) => {
    if (params.action === 'create' && params.data.ownerAccountId && params.data.ownerAccountId !== userState.id) {
        throw new AuthError('Unauthorized');
    }
    if (params.action === 'update') {
        if (params.data.ownerAccountId && params.data.ownerAccountId !== params.prevData.ownerAccountId) {
            throw new AuthError('Unauthorized');
        }
        if (params.data.visibility === 'private' &&
            params.prevData.visibility !== 'private' &&
            params.createdBy !== userState.id &&
            !requireAnySystemPermission(userState, 'all-organizations-admin', 'manage-groups')) {
            throw new AuthError('Unauthorized');
        }
    }
    if (appState.settings.buildOrganizationTreeEnabled) {
        checkOrganizations(params, appState.organizations);
    }
    if (requireAnySystemPermission(userState, 'manage-groups')) {
        return;
    }
    const orgIds = collectOrgIdsForAnyOrgPermission(userState, 'view-and-message-members', 'create-notifications', 'manage-members');
    if (orgIds.length > 0) {
        if (params.action === 'create') {
            // any org-admin can create group
        }
        else {
            // update and delete have the same permissions
            if (params.createdBy === userState.id) {
                // owner can always access
            }
            else if (params.prevData.visibility === 'any-admin') {
                // any org-admin can access
            }
            else if (Array.isArray(params.prevData.visibility) && arrayIncludesAny(params.prevData.visibility, orgIds)) {
                // is org-admin in shared org
            }
            else {
                throw new AuthError('Unauthorized');
            }
        }
    }
    else {
        // cannot access groups, needs to be org-admin in some org
        throw new AuthError('Unauthorized');
    }
};
function authGroupGet(userState, group) {
    authGroup(userState, group);
    return group;
}
function authGroupList(userState, group) {
    authGroup(userState, group);
    return group;
}
export function authGroup(userState, group) {
    if (requireAnySystemPermission(userState, 'manage-groups')) {
        return;
    }
    const orgIds = collectOrgIdsForAnyOrgPermission(userState, 'view-and-message-members', 'create-notifications', 'manage-members');
    if (orgIds.length > 0) {
        if (group.columns.ownerAccountId === userState.id) {
            // owner can always access
        }
        else if (group.columns.visibleToAnyAdmin) {
            // any org-admin can access
        }
        else if (arrayIncludesAny(group.columns.visibleToOrgAdmins, orgIds)) {
            // is org-admin in shared org
        }
        else {
            throw new AuthError('Unauthorized');
        }
    }
    else {
        // cannot access groups, needs to be org-admin in some org
        throw new AuthError('Unauthorized');
    }
}
export function arrayIncludesAny(array, includes) {
    for (const value of includes) {
        if (array.includes(value)) {
            return true;
        }
    }
    return false;
}
export const onAuthImport = (appState, userState) => {
    if (!requireAnySystemPermission(userState, 'import-groups') && !requireAnyOrgPermission(userState, 'manage-members')) {
        throw new AuthError('Unauthorized');
    }
};
